import { addDays, endOfDay, startOfDay, startOfMonth, endOfMonth, addMonths, startOfWeek, endOfWeek } from 'date-fns';

export const defineds = {
    startOfWeek: startOfWeek(new Date()),
    endOfWeek: endOfWeek(new Date()),
    startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
    startOfLast2Week: startOfWeek(addDays(new Date(), -14)),
    endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
    startOfLast30Days: startOfDay(addDays(new Date(), -30))
};

export const getDefineds = () => {
    const now = new Date();
    return {
        startOfWeek: startOfWeek(now),
        endOfWeek: endOfWeek(now),
        startOfLastWeek: startOfWeek(addDays(now, -7)),
        startOfLast2Week: startOfWeek(addDays(now, -14)),
        endOfLastWeek: endOfWeek(addDays(now, -7)),
        startOfToday: startOfDay(now),
        endOfToday: endOfDay(now),
        startOfYesterday: startOfDay(addDays(now, -1)),
        endOfYesterday: endOfDay(addDays(now, -1)),
        startOfMonth: startOfMonth(now),
        endOfMonth: endOfMonth(now),
        startOfLastMonth: startOfMonth(addMonths(now, -1)),
        endOfLastMonth: endOfMonth(addMonths(now, -1)),
        startOfLast30Days: startOfDay(addDays(now, -30))
    };
};


